<div class="white-bg no-padding no-margin">
  <breadcrumbs>
    <breadcrumb route="/" label="{{'Dashboard' | translate | async}}"></breadcrumb>
    <breadcrumb [currentRoute]="true" label="{{'Measurement Points' | translate | async}}"></breadcrumb>
  </breadcrumbs>
</div>

<div class="page-padding">
  <!-- <div class="center" *ngIf="equipmentDetails == null">
      <mat-spinner></mat-spinner>
  </div> -->
  <div class="panel">
    <div class="panel__header">
      <span class="panel__header__title">
        <!-- <strong> {{ Translate('Select Filters for Components to be displayed and Edit Data') }}</strong> -->
        <strong> {{'Select Filters to display and edit data'  | translate | async}}</strong>
        <mat-radio-group aria-label="Select an option" color="warn" [(ngModel)]="componentType"
          (change)="componnetTypeChange()">
          <mat-radio-button [value]="1">{{'Rope Shovel'  | translate | async}}</mat-radio-button>
          <mat-radio-button [value]="2">{{"URC"  | translate | async}}</mat-radio-button>
        </mat-radio-group>
      </span>

    </div>
    <div class="row" style="margin:22px">

      <mat-label>{{'Make'  | translate | async}} :<span class="validation">* </span></mat-label>
      <mat-form-field style="width:14%" required>

        <mat-select [(ngModel)]="selectedMakeId" (selectionChange)="makeSelected()">
          <mat-option [value]="0" disabled>{{"Select Make"  | translate | async}}</mat-option>
          <mat-option *ngFor="let make of makeList" [value]="make.Id">{{ make.Name }}</mat-option>
        </mat-select>
      </mat-form-field>


      <mat-label style="margin-left: 40px;">{{"Model"  | translate | async}} :<span class="validation">* </span></mat-label>
      <mat-form-field style="width:14%" required>

        <mat-select [(ngModel)]="selectedModelId" (selectionChange)="modelSelected($event)">
          <mat-option [value]="0" disabled>{{'Select Model'  | translate | async}}</mat-option>
          <mat-option *ngFor="let model of modelList" [value]="model.Id">{{ model.Name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- <mat-spinner class="loading-spinner" *ngIf="modelLoading" [diameter]="50"></mat-spinner> -->

      <mat-label style="margin-left: 40px;">{{'Dealer Group'  | translate | async}}:</mat-label>
      <mat-form-field style="width:14%">

        <mat-select [(ngModel)]="dealergroupId" (selectionChange)="dealerSelected($event)">
          <mat-option [value]="0" disabled>{{'Select Dealer Group'  | translate | async}}</mat-option>
          <mat-option *ngFor="let dealer of userDealerGroup" [value]="dealer.Id">{{ dealer.Name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row">
      <div class="col-lg-8 button-des">
        <button mat-raised-button style="z-index: 99;" (click)="Reset()">
          <span>{{'Reset'  | translate | async}}</span>
        </button>
        <button mat-raised-button color="warn" style="z-index: 99;" (click)="Search()">
          <mat-icon class="btn-icon">search</mat-icon>
          <span>{{'Search'  | translate | async}}</span>
        </button>
      </div>
    </div>
    <!-- Existing Functionality COmmented Aditya Thakur 25-Oct -->
    <!-- <mat-grid-list cols="20" rowHeight="50px" *ngIf="searchComponentOption == 1" [@fadeInOut]>
      <mat-grid-tile [colspan]="2" [rowspan]="1">
        Make
      </mat-grid-tile>
      <mat-grid-tile [colspan]="8" [rowspan]="1">
        <select class="select" [ngModel]="selectedMakeId" (change)="makeSelected($event.target.value)">
          <option value=0 disabled selected>Select Make</option>
          <option *ngFor="let make of makeList" [value]="make.Id">{{ make.Name }}</option>
        </select>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="10" [rowspan]="4">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="2" [rowspan]="1">
        Model
      </mat-grid-tile>
      <mat-grid-tile [colspan]="8" [rowspan]="1">
        <select class="select" [ngModel]="selectedModelId" (change)="modelSelected($event.target.value)" required>
          <option value=0 disabled selected>Select Model</option>
          <option *ngFor="let model of modelList" [value]="model.Id">{{ model.Name }}</option>
        </select>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="2" [rowspan]="1">
        Type
      </mat-grid-tile>
      <mat-grid-tile [colspan]="8" [rowspan]="1">
        <select class="select" [ngModel]="selectedCompartTypeId" (change)="compartTypesSelected($event.target.value)"
          required>
          <option value="0" disabled selected>Select Type</option>
          <option *ngFor="let compartType of _availableCompartTypes" [value]="compartType.Id">{{ compartType.Title }}
          </option>
        </select>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="2" [rowspan]="1">

      </mat-grid-tile>
      <mat-grid-tile [colspan]="8" [rowspan]="1">
        <div>
          <button mat-raised-button color="warn" style="z-index: 99;" (click)="Search()">
            <span class="button__text">Search</span>
          </button>
          <button mat-raised-button color="warn" style="z-index: 99;" (click)="Reset()">
            <span class="button__text">Reset</span>
          </button>
        </div>
      </mat-grid-tile>



    </mat-grid-list> -->

  </div>


  <mat-accordion class="example-headers-align" multi style="padding: 10px; margin-top: 20px;">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="expansion-header"> {{'Select the component you would like to edit the measurement points for'  | translate | async}} </mat-panel-title>

      </mat-expansion-panel-header>

      <div class="panel panel--components" *ngIf="searchComponentOption == 1" [@fadeInOut]>
        <div class="panel__header">
          <span class="panel__header__title">
          </span>
        </div>
        <div class="panel__content no-padding">
          <table class="table table--striped table--half-width">
            <thead>
              <tr>
                <th>{{'Make' | translate | async}}</th>
                <th>{{'Models' | translate | async}}</th>
                <th>{{'Component Type' | translate | async}}</th>
                <th>{{'Component' | translate | async}}</th>
                <th>{{'# of Active Observation Pts.' | translate | async}}</th>
                <th>{{'# of In-Active Observation Pts.' | translate | async}}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="table-row-style" *ngFor="let component of components" style="cursor: pointer;"
                (click)="openMeasurementPoints(component.CompartId ,component.CompartTypeId)">
                <td style="cursor: pointer;">{{component.Make}}
                </td>
                <td (click)="openMeasurementPoints(component.CompartId,component.CompartTypeId)"
                  style="cursor: pointer;">{{component.Models}}
                </td>
                <td (click)="openMeasurementPoints(component.CompartId,component.CompartTypeId)"
                  style="cursor: pointer;">
                  {{component.CompartType}}
                </td>
                <td (click)="openMeasurementPoints(component.CompartId,component.CompartTypeId)"
                  style="cursor: pointer;">
                  {{component.CompartName}}
                </td>
                <td (click)="openMeasurementPoints(component.CompartId,component.CompartTypeId)"
                  style="cursor: pointer;">
                  {{component.ActiveObsCount}}</td>
                <td (click)="openMeasurementPoints(component.CompartId,component.CompartTypeId)"
                  style="cursor: pointer;">
                  {{component.InActiveObsCount}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <div *ngIf="measurementPointShow">
    <div class="panel" *ngIf="compartViewModel != null" [@enterAnimation]>
      <div class="panel__content flex flex--align-center">
        <!-- <div class="overall-eval-container">
                  <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo" />
                  <div class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.PercentWorn | wornPercentageToEval }}">
                      {{equipmentDetails.PercentWorn | number:'1.0-1'}}%
                  </div>
              </div> -->
        <div class="column-container flex-grow">
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Componet Type') }}
              </span>
              <span class="text-block__important">
                {{compartViewModel.CompartType}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Component') }}
              </span>
              <span class="text-block__important">
                {{compartViewModel.CompartName}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Make') }}
              </span>
              <span class="text-block__important">
                {{compartViewModel.Make}}
              </span>
            </div>
            <!-- <div class="text-block">
              <span class="text-block__label">
                {{ Translate('Models') }}
              </span>
              <span class="text-block__important">
                {{compartViewModel.Models}}
              </span>
            </div> -->
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                <!-- {{ Translate('Last Inspection Date') }} -->
              </span>
              <span class="text-block__important">
                <div style="margin-left: 30px">
                  <span>Inches</span>
                  <ui-switch [(ngModel)]="UOM" (click)="ConvertUOM($event)"></ui-switch>
                  <span>Mm</span>
                </div>
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                <!-- {{ Translate('Next Inspection Date') }} -->
              </span>
              <span class="text-block__important">
                <!-- {{ equipmentDetails.NextInspectionDate }} -->
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                <!-- {{ Translate('Meter Reading (SMU)') }} -->
              </span>
              <span class="text-block__important">
                <!-- {{equipmentDetails.Smu}} -->
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                <!-- {{ Translate('Life to Date (LTD)') }} -->
              </span>
              <span class="text-block__important">
                <!-- {{equipmentDetails.Ltd}} -->
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                <!-- {{ Translate('Make') }} -->
              </span>
              <span class="text-block__important">
                <!-- {{equipmentDetails.Make}} -->
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                <!-- {{ Translate('Model') }} -->
              </span>
              <span class="text-block__important">
                <!-- {{equipmentDetails.Model}} -->
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">

                <a class="button button--primary" style="margin-bottom: 16px;"
                  (click)="addMeasurementPoints(compartViewModel)">
                  <i class="material-icons button__icon">add</i>
                  <span class="button__text">{{Translate('Add Measurement Points')}}</span>
                </a>
                <!-- {{ Translate('Family') }} -->
              </span>
              <span class="text-block__important">
                <!-- {{equipmentDetails.Family}} -->
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-lg-12" style="text-align: right;">
        <div *ngIf="measurementPointsNew.length>0;else disabled">
          <button mat-raised-button color="warn" (click)="CopyObsPoint()">
            {{'Copy Obs. Pts.'  | translate | async}}
          </button>
        </div>
        <ng-template #disabled>
          <button mat-raised-button [disabled]="true">
            {{'Copy Obs. Pts.'  | translate | async}}
          </button>
        </ng-template>

      </div>
    </div>

    <div *ngIf="showPopup" class="popup-overlay">
      <div class="popup">
        <mat-radio-group aria-label="Select an option" color="warn" [(ngModel)]="copyObsType">
          <mat-radio-button [value]="3">{{'Model'  | translate | async}}</mat-radio-button>
          <mat-radio-button [value]="4">{{'Dealer Group'  | translate | async}}</mat-radio-button>
        </mat-radio-group>

        <div class="row" style="margin-top: 20px;">
          <div *ngIf="copyObsType==3">
            <!-- <mat-label>Model :</mat-label>
            <mat-form-field>

              <mat-select [(ngModel)]="selectedModelCopyObsId" (selectionChange)="modelSelected($event)">
                <mat-option [value]="0" disabled>Select Model</mat-option>
                <mat-option *ngFor="let model of modelList" [value]="model.Id">{{ model.Name }}</mat-option>
              </mat-select>
            </mat-form-field> -->
            <mat-label>{{'Model'  | translate | async}} :</mat-label>
            <mat-form-field class="search-select-margin" appearance="outline" style="width:50%">
              <mat-icon matPrefix style=" color: #d7cfcf;font-size: 20px; ">search</mat-icon>
              <input type="text" placeholder="{{'Model'  | translate | async}}" (input)="changeModelAutoComplete($event)" matInput
                [matAutocomplete]="auto3" [ngModelOptions]="{ standalone: true }" [(ngModel)]="modelTitle"
                #autoCompleteInput2="matAutocompleteTrigger" name="Modelauto_">
              <mat-autocomplete [(ngModel)]="modelTitle" #model_auto="ngModel" #auto3="matAutocomplete"
                (optionSelected)="onModelSelected($event.option)">
                <!-- <mat-option [value]="0">None</mat-option> -->
                <mat-option [value]="model.Title" *ngFor="let model of filteredModels">
                  {{model.Title}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div *ngIf="copyObsType==4">
            <mat-label>{{'Dealer Group'  | translate | async}} :</mat-label>
            <mat-form-field appearance="outline">
              <mat-select [(ngModel)]="dealergroupCopyObsId" (selectionChange)="dealerSelected($event)">
                <mat-option [value]="0" disabled>{{'Select Dealer'  | translate | async}}</mat-option>
                <mat-option *ngFor="let dealer of userDealerGroup" [value]="dealer.Id">{{ dealer.Name
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <p style="color:red" *ngIf="IsComponentTableShow">{{'Select a component where to copying obs points.'  | translate | async}}</p>
          <table class="table table--striped table--half-width" *ngIf="IsComponentTableShow">
            <thead>
              <tr>
                <th>{{'Make' | translate | async}}</th>
                <th>{{'Models' | translate | async}}</th>
                <th>{{'Component Type' | translate | async}}</th>
                <th>{{'Component' | translate | async}}</th>
                <th>{{'# of Active Observation Pts.' | translate | async}}</th>
                <th>{{'# of In-Active Observation Pts.' | translate | async}}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr class="table-row-style" *ngFor="let component of compartForCopy" style="cursor: pointer;">
                <td>{{component.Make}}</td>
                <td>{{component.Models}}</td>
                <td>{{component.CompartType}}</td>
                <td>{{component.CompartName}}</td>
                <td>{{component.ActiveObsCount}}</td>
                <td> {{component.InActiveObsCount}}</td>
                <td><mat-checkbox class="example-margin"
                    (change)="OnSlectComponent(component.CompartId)"></mat-checkbox></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row" style="text-align: right;">
          <button (click)="togglePopup()" mat-raised-button>{{'Close'  | translate | async}}</button>
          <button mat-raised-button color="warn" (click)="CopyObsPoint()">{{'Save'  | translate | async}}</button>
        </div>
      </div>
    </div>

    <div class="panel__content no-padding">
      <div>
        <table class="table table--striped table--full-width">
          <thead>
            <tr>
              <!-- <th style="width: 20px">More</th> -->
              <th style="width: 50px">{{'Image'  | translate | async}}</th>
              <th>{{'Type'  | translate | async}}</th>
              <th>{{'Make'  | translate | async}}</th>
              <th>{{'Model'  | translate | async}}</th>
              <th>{{'Component Type'  | translate | async}}</th>
              <th>{{'Component'  | translate | async}}</th>
              <th *ngIf="compartViewModel.CompartType=='TrackFrame'">{{'Sub-Component'  | translate | async}}</th>
              <th>{{'Measurement Point'  | translate | async}}</th>
              <!-- <th>Obs.Type/Tool</th> -->
              <th>0% {{'Worn Dim.'  | translate | async}}</th>
              <th>100% {{'Worn Dim.'  | translate | async}}</th>
              <th>{{'Tolerance'  | translate | async}}</th>
              <th>{{'Dealer'  | translate | async}}<br> {{'Group'  | translate | async}}</th>
              <th></th>
              <th *ngIf="compartViewModel.CompartType!='TrackFrame'"></th>

              <th>{{'Obs.Pt Order'  | translate | async}}</th>
              <th></th>
              <th class="align-right">{{'Status'  | translate | async}} <i class="material-icons"
                  [matTooltip]="'Points that are Enabled will be shown for Inspection'">info</i></th>

              <!-- <th>Visibility</th> -->

              <!-- <th  *ngIf="compartViewModel.CompartType=='TrackFrame'">Component</th>
             
              <th *ngIf="compartViewModel.CompartType!='TrackFrame'">Method</th>
              <th>0% Worn Dim.</th>
              <th>100% Worn Dim.</th>
              <th></th>
              <th class="align-right">Status <i class="material-icons" [matTooltip]="'Points that are Enabled will be shown for Inspection'">info</i></th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let point of measurementPoints; let i = index" class="table-row-style" click-stop-propagation>

              <td>
                <img class="measurement-image"
                  src="/Api/Application/getMeasurementPointsThumbnail/?measurementPonitsId={{point.MeasurementPonitId}}" />
              </td>
              <td *ngIf="compartViewModel.CompartType =='TrackFrame'">WSRE</td>
              <td *ngIf="compartViewModel.CompartType !='TrackFrame'">RSH/Hydraulic</td>
              <td>{{compartViewModel.Make}}</td>
              <td *ngIf="compartViewModel.CompartType !='TrackFrame'">{{compartViewModel.Models}}</td>
              <td *ngIf="compartViewModel.CompartType =='TrackFrame'">{{point.ModelName}}</td>

              <td>{{compartViewModel.CompartType}}</td>
              <td>{{compartViewModel.CompartName}}</td>
              <td *ngIf="compartViewModel.CompartType =='TrackFrame'">{{point.WSRETypeName}}</td>
              <td style="cursor:pointer ;" title="Edit Observation Point Limits">{{point.Name}}</td>

              <!-- <td>{{point.ToolName}}</td> -->
              <td *ngIf="compartViewModel.CompartType != 'TrackFrame'">{{point.StartingDim}}</td>
              <td *ngIf="compartViewModel.CompartType != 'TrackFrame'">{{point.EndingDim}}</td>

              <td *ngIf="compartViewModel.CompartType == 'TrackFrame'">{{point.worn_0_prec}}</td>
              <td *ngIf="compartViewModel.CompartType == 'TrackFrame'">{{point.worn_100_prec_Dim}}</td>
              <td>{{
                  !point.Tolerance ? '' : 
                  point.ToleranceType === 'Both' ? '+/- ' + point.Tolerance :
                  point.ToleranceType === 'Minus' ? '- ' + point.Tolerance :
                  point.ToleranceType === 'Plus' ? '+ ' + point.Tolerance :
                  point.ToleranceType === 'Max' ? 'Max' :
                  ''
                }}
             </td>
              <!-- <td *ngIf="point.ToleranceType == 'Both'"> +/- {{point.Tolerance}}</td>
              <td *ngIf="point.ToleranceType == 'Minus'">- {{point.Tolerance}}</td>
              <td *ngIf="point.ToleranceType == 'Plus'">+ {{point.Tolerance}}</td>
              <td *ngIf="point.ToleranceType == 'Max'"> Max</td> -->
              <td>
                   <div *ngIf="point.DealerGroupId[0]==0;else OnlySelect">
                    <mat-form-field *ngIf="!point.isDisabled" style="width:45%">
                      <mat-select [(ngModel)]="point.DealerGroupId" id="point.MeasurementPonitId"
                        (selectionChange)="compartSelected(point.MeasurementPonitId,$event, point.Name)" multiple>
                        <mat-option [value]="0" [disabled]="true">Default</mat-option>
                        <mat-option *ngFor="let dealer of userDealerGroup" [value]="dealer.Id">{{ dealer.Name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                   </div>
                   <ng-template #OnlySelect>
                    <mat-form-field  style="width:45%">
                      <mat-select [(ngModel)]="point.DealerGroupId[0]" id="point.MeasurementPonitId">
                        <!-- <mat-option [value]="0" [disabled]="true">Default</mat-option> -->
                        <mat-option *ngFor="let dealer of userDealerGroup" [value]="dealer.Id">{{ dealer.Name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                   </ng-template>
                
                <!-- <div *ngIf="point.DealerGroupName!='';else default">{{point.DealerGroupName}}</div>
                <ng-template #default> Default</ng-template> -->
              </td>
              <td title="Update Observation Point details">
                <button mat-raised-button color="warn" (click)="UpdateMP(point,compartViewModel)" style="width:91%">
                  <span class="button__text">{{'Update Details'  | translate | async}}</span>
                </button>
              </td>

              <td *ngIf="compartViewModel.CompartType != 'TrackFrame'" title="Update Limits for Measurement Point">
                <button mat-raised-button color="warn" (click)="editMeasurementPoints(point)" style="width:91%">
                  <span class="button__text">{{'Update Limits' | translate | async}}</span>
                </button>
              </td>

              <td>
                <div style="display: flex;">
                  <span></span>
                  <div >
                    <span *ngIf="isFirstComponentInList(point, i)" style="padding-left: 24px;"> </span>
                    <span *ngIf="!isFirstComponentInList(point, i)">
                      <mat-icon style="vertical-align: middle; cursor: pointer;"
                        (click)="OrderUP(point.Order,point.MeasurementPonitId,point.Name)">arrow_upward</mat-icon>
                    </span>
                  </div>

                  <div >
                    <span *ngIf="isLastComponentInList(point, i)" ></span>
                    <span *ngIf="!isLastComponentInList(point, i)">
                    <mat-icon style="vertical-align: middle; cursor: pointer;"
                      (click)="OrderDown(point.Order,point.MeasurementPonitId, point.Name)">arrow_downward</mat-icon>
                 </span>
                    </div>
                </div>
              </td>

              <td>
                <span *ngIf="point.DealerGroupId[0]==0;else checkDisabled">
                <mat-checkbox *ngIf="!point.isDisabled" class="example-margin"
                  (change)="OnSelect(point)"></mat-checkbox>
                </span>
                <ng-template>
                  <mat-checkbox *ngIf="!point.isDisabled" class="example-margin"
                  [disabled]="true"></mat-checkbox>
                </ng-template>
              </td>

              <td class="align-right" click-stop-propagation [matMenuTriggerFor]="operation"
                (click)="$event.stopPropagation();">
                <div>
                  <div class="editable-text" style="color:green" *ngIf="!point.isDisabled"> {{'Enabled' | translate | async}}</div>
                  <div class="editable-text" style="color:red" *ngIf="point.isDisabled"> {{'Disabled' | translate | async}}</div>
                  <mat-menu #operation="matMenu">
                    <button mat-menu-item (click)="changeMeasurementPointStatus(true, point)">
                      <mat-icon>block</mat-icon>
                      <span>{{'Disable' | translate | async}}</span>
                    </button>
                    <button mat-menu-item (click)="changeMeasurementPointStatus(false,point)">
                      <mat-icon>lock_open</mat-icon>
                      <span>{{'Enable' | translate | async}}</span>
                    </button>
                  </mat-menu>
                </div>

              </td>
              <!-- <td class="align-right">
                <mat-form-field *ngIf="!point.isDisabled" style="width:37%">
                  <mat-select [(ngModel)]="point.IsVisible" id="point.MeasurementPonitId"
                    (selectionChange)="OnChangeVisibilty($event,point.MeasurementPonitId)">
                    <mat-option [value]="1">Visible</mat-option>
                    <mat-option [value]="0">Hide</mat-option>
                  </mat-select>
                </mat-form-field>
              </td> -->
            </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
